import { axiosAjax } from '@app/src/config/axios';
import { hydrateData } from './hydrators';
import { SelectItemModel } from '@app/src/common/Select/SelectModel';

export const typeOperationService = {
  async get(categoryId: number): Promise<SelectItemModel[]> {
    try {
      const { data } = await axiosAjax.get(process.env.API_OPERATION.replace(':categoryId', '' + categoryId));
      if (data.error) {
        throw new Error();
      }
      return hydrateData(data.data);
    } catch (e) {
      throw new Error(e);
    }
  }
};
